'use client';

import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import { FC } from 'react';

import styles from './button.module.css';

// Extend MUI ButtonProps to add any custom props you need
interface ButtonProps extends Omit<MuiButtonProps, 'variant'> {
  variant?: 'contained' | 'outlined' | 'text' | 'tonal';
  size?: 'small' | 'medium' | 'large';
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

const ButtonCommon: FC<ButtonProps> = ({
  children,
  variant = 'contained',
  size = 'medium',
  startIcon,
  endIcon,
  className,
  ...props
}) => {
  // Build className from CSS modules
  const buttonClasses = [styles.button, styles[variant], styles[size], className]
    .filter(Boolean)
    .join(' ');

  return (
    <MuiButton
      startIcon={startIcon}
      variant={variant === 'tonal' ? 'contained' : variant}
      size={size}
      {...props}
      endIcon={endIcon}
      className={buttonClasses}
    >
      {children}
    </MuiButton>
  );
};

export default ButtonCommon;
